import React from 'react';
import SettingsForm from '../ui-kit/SettingsForm';

const periodOptions = () =>
  ['year', 'quarter', 'month', 'week'].map(p => ({
    value: p,
    name: I18n.t(`classy_enum.period.${p}`)
  }));

const timeUnitOptions = () =>
  ['hour', 'shift'].map(p => ({
    value: p,
    name: I18n.t(`reports.group_reports.standby_duty_hours.mode.${p}s`)
  }));

const Settings = ({ updateWidgetSettingsField, widgetSettings }) => (
  <SettingsForm
    updateWidgetSettingsField={updateWidgetSettingsField}
    widgetSettings={widgetSettings}
    withAutoResizeHeight={true}
    withAutoScroll={true}
  >
    <SettingsForm.Section>
      <SettingsForm.Section.Header>{I18n.t('general')}</SettingsForm.Section.Header>
      <SettingsForm.Section.Content>
        <SettingsForm.ToggleField
          fieldName="show_breakdown"
          label={I18n.t('dashboards.widget_archetypes.contract_compliance.show_breakdown')}
        />
        <SettingsForm.ToggleField
          fieldName="show_carousel"
          label={I18n.t('dashboards.widget_archetypes.contract_compliance.show_carousel')}
        />
        <SettingsForm.Select
          fieldName="carousel_period_type"
          options={periodOptions()}
          label={I18n.t('dashboards.widget_archetypes.contract_compliance.carousel_period_type')}
        />
        <SettingsForm.RadioButtonGroup
          fieldName="time_unit"
          options={timeUnitOptions()}
          label={I18n.t('attributes.time_unit')}
        />
        <SettingsForm.Select
          fieldName="table_period_type"
          options={periodOptions()}
          label={I18n.t('dashboards.widget_archetypes.contract_compliance.table_period_type')}
        />
      </SettingsForm.Section.Content>
    </SettingsForm.Section>
  </SettingsForm>
);

export default Settings;
